/*
 * @Version: 1.0
 * @Autor: zhangqi
 * @Date: 2022-06-24 15:39:59
 * @LastEditors: zhangqi
 * @LastEditTime: 2022-06-28 17:39:19
 */

import Singleton from "../clazz/Singleton";

export class Operation extends Singleton {
  constructor() {
    super();
    this.history = [];
  }

  /**
   * @description: 默认获取最后一项
   * @param {*} index
   * @return {*}
   * @author: zhangqi
   */
  getHistory(index) {
    return this.history[this.history.length - 1];
  }

  push(item) {
    this.history.push(item);
  }

  /**
   * @description: 第一项默认为初始化数据，不进行删除操作
   * @return {*}
   * @author: zhangqi
   */
  pop() {
    if(this.history.length > 1) {
      this.history.pop();
    }
  }

  clear() {
    this.history = [];
  }
}

